import reducer from './reducer';
import { MODULE_NAME, NOTIFICATION_TYPE } from './constants';

export { pushNotification, dismissFirstNotification } from './actions';

export { selectFirstNotification } from './selectors';

export { NOTIFICATION_TYPE };

export default {
    reducer,
    moduleName: MODULE_NAME
};
